module.exports = __webpack_public_path__ + "static/media/users_password_icon.441418ac.png";